import { Input } from "components"
import { Select, TextArea } from "components2"
import { useFormikContext } from "formik"
import { Fragment } from "react"
import { useDropdownMenu, useDropdownModul } from "../hooks"

export const FormItemPermintaanPerubahanData = () => {
  const { values, errors, touched, setValues, handleChange } = useFormikContext()

  const modulList = useDropdownModul()

  const menuList = useDropdownMenu({ kode_hak_akses_parent: values.kode_modul })

  return (
    <Fragment>
      <Select
        label="Modul"
        placeholder="Pilih Modul"
        name="kode_modul"
        defaultValue={modulList?.data?.find(v => v.value === values.kode_modul)}
        options={modulList.data ?? []}
        onChange={(val) =>
          setValues({
            ...values,
            kode_modul: val.value,
          })
        }
        error={errors.kode_modul && touched.kode_modul && true}
        errorText={touched.kode_modul && errors.kode_modul}
      />

      <Select
        key={values.kode_modul}
        label="Menu"
        placeholder="Pilih Menu"
        name="kode_menu"
        defaultValue={menuList?.data?.find(v => v.value === values.kode_menu)}
        options={menuList.data ?? []}
        disable={!values.kode_modul}
        onChange={(val) =>
          setValues({
            ...values,
            kode_menu: val.value,
          })
        }
        error={errors.kode_menu && touched.kode_menu && true}
        errorText={touched.kode_menu && errors.kode_menu}
      />


      <Input
        label="No. Referensi Transaksi"
        name="no_referensi_transaksi"
        value={values.no_referensi_transaksi}
        onChange={handleChange}
        error={errors.no_referensi_transaksi && touched.no_referensi_transaksi && true}
        errorText={touched.no_referensi_transaksi && errors.no_referensi_transaksi}
      />

      {/* <Input
        label="Atribut"
        name="atribut_salah"
        value={values.atribut_salah}
        onChange={handleChange}
        error={errors.atribut_salah && touched.atribut_salah && true}
        errorText={touched.atribut_salah && errors.atribut_salah}
      />

      <Input
        label="Nilai Saat Ini"
        name="nilai_sebelum"
        value={values.nilai_sebelum}
        onChange={handleChange}
        error={errors.nilai_sebelum && touched.nilai_sebelum && true}
        errorText={touched.nilai_sebelum && errors.nilai_sebelum}
      />

      <Input
        label="Nilai Baru"
        name="nilai_diminta"
        value={values.nilai_diminta}
        onChange={handleChange}
        error={errors.nilai_diminta && touched.nilai_diminta && true}
        errorText={touched.nilai_diminta && errors.nilai_diminta}
      />

      <TextArea
        label="Alasan Pengubahan"
        name="alasan_pengubahan"
        rows={5}
        value={values.alasan_pengubahan}
        onChange={handleChange}
        error={errors.alasan_pengubahan && touched.alasan_pengubahan && true}
        errorText={touched.alasan_pengubahan && errors.alasan_pengubahan}
      /> */}
    </Fragment>
  )
}